import { render, staticRenderFns } from "./CodeModal.vue?vue&type=template&id=547113d3&"
import script from "./CodeModal.vue?vue&type=script&lang=js&"
export * from "./CodeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports